import type { Guestrides_Bool_Exp } from '@gql/base-types';

import { customerScopeFilter, ridesWindowFilter } from '@features/products/counts/countFilters';
import type { CountWindow } from '@features/products/counts/productCounts';

export const buildGuestRidesCountsVariables = ({ customerIds, window }: { customerIds: number[]; window: CountWindow }) => ({
  scope: customerScopeFilter<Guestrides_Bool_Exp>(customerIds),
  window: ridesWindowFilter<Guestrides_Bool_Exp>(window),
});
